import axios from "axios"
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag"
import { clienteInfo } from "utils/DatosUsuarioLocalStorag"
export const cargarMapa = async () => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listarMapas", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const cargarMapaPorEspacio = async (nombreEspacio) => {
    try {
        if (!nombreEspacio) {
            return await cargarMapa()
        }

        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listarMapas_nombre/" + encodeURIComponent(nombreEspacio), {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })

        if (Array.isArray(data?.data) && data.data.length > 0) {
            return data
        }

        // Verificar mapas custom antes del fallback general
        const customResp = await cargarMapaCustomPorEspacio(nombreEspacio)
        if (Array.isArray(customResp?.data) && customResp.data.length > 0) {
            return customResp
        }

        return await cargarMapa()
    } catch (error) {
        return await cargarMapa()
    }
}
export const guardarMapar = async (parm) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/guardarMapa", {...parm,...parmspro}, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const editarMapa = async (parm) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    try {
        const { data } = await axios.put("https://api.t-ickets.com/ms_login/actualizarMapa", {...parm,...parmspro}, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        
        return error
    }
}
export const eliminaMapa = async (parm) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    try {
        // BUG FIX: axios.delete solo acepta (url, config); el 3er arg con los
        // headers se ignoraba silenciosamente (sin authorization-ticket -> 401).
        const { data } = await axios.delete("https://api.t-ickets.com/ms_login/eliminarMapa/" + parm, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            },
            data: parmspro
        })
        return data
    } catch (error) {
        return error
    }
}

const CUSTOM_HEADERS = {
    'Content-Type': 'application/json',
    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
}
const CUSTOM_BASE = "https://api.t-ickets.com/ms_login"

export const cargarMapaCustom = async () => {
    try {
        const { data } = await axios.get(`${CUSTOM_BASE}/listarMapasCustom`, { headers: CUSTOM_HEADERS })
        return data
    } catch (error) {
        return { success: false, data: [] }
    }
}

export const cargarMapaCustomPorEspacio = async (nombre) => {
    try {
        const { data } = await axios.get(`${CUSTOM_BASE}/listarMapasCustom_nombre/${encodeURIComponent(nombre)}`, { headers: CUSTOM_HEADERS })
        return data
    } catch (error) {
        return { success: false, data: [] }
    }
}

export const guardarMapaCustom = async (parm) => {
    try {
        const { data } = await axios.post(`${CUSTOM_BASE}/guardarMapaCustom`, parm, { headers: CUSTOM_HEADERS })
        return data
    } catch (error) {
        return { success: false }
    }
}

export const editarMapaCustom = async (parm) => {
    try {
        const { data } = await axios.put(`${CUSTOM_BASE}/actualizarMapaCustom`, parm, { headers: CUSTOM_HEADERS })
        return data
    } catch (error) {
        return { success: false }
    }
}

export const eliminarMapaCustom = async (id) => {
    try {
        const { data } = await axios.delete(`${CUSTOM_BASE}/eliminarMapaCustom/${id}`, { headers: CUSTOM_HEADERS })
        return data
    } catch (error) {
        return { success: false }
    }
}